import { Wrench, Droplet, Zap, ThermometerSun } from "lucide-react";

const Tailor = () => {

const services = [
    {
      title: "Appliance Repair",
      icon: <Wrench className="h-10 w-10 text-red-500" />,
    },
    {
      title: "Plumbing",
      icon: <Droplet className="h-10 w-10 text-blue-500" />,
    },
    {
      title: "Electrical",
      icon: <Zap className="h-10 w-10 text-yellow-400" />,
    },
    {
      title: "HVAC",
      icon: <ThermometerSun className="h-10 w-10 text-green-500" />,
    },
  ];

const data = [
    {
      challenge: "Missed appointments, no-shows, or unreliable vendors",
      solution: "Strict appointment compliance, and status updates."
    },
    {
      challenge: "Lack of communication from contractors",
      solution: "Dedicated coordinator + live updates + fast response by call, email, or chat."
    },
    {
      challenge: "High repair costs and markups on simple jobs",
      solution: "Transparent flat-rate or hourly pricing + fair parts markup = no surprise invoices."
    },
    {
      challenge: "Slow turnaround times, tenant complaints",
      solution: "24–48 hour response time. Emergency options available."
    },
    {
      challenge: "Need to service multiple properties across the city",
      solution: "We cover whole city and nearby areas with multi-tech dispatch and routing systems."
    },
    {
      challenge: "Juggling too many vendors for different trades",
      solution: "One-stop solution: appliance, HVAC, plumbing, electrical, and handyman — all in-house."
    },
    {
      challenge: "Warranty company with high call volume & SLAs to meet",
      solution: "Scalable service capacity and API integration to meet volume and compliance requirements."
    },
    {
      challenge: "Property managers handling dozens of tenants daily",
      solution: "Dedicated B2B workflow and reporting to support your lease cycles and renewal schedules."
    },
    {
      challenge: "Need a partner who represents your brand professionally",
      solution: "Uniformed, trained techs with respectful conduct and tenant-friendly communication."
    }
  ];

    return (
        <section className="py-14" id="tailor">
            
            <div className="max-w-screen-xl mx-auto px-4 text-gray-600 md:px-8">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center mb-16">
          {services.map((service, index) => (
            <div key={index} className="flex flex-col items-center shadow-xl rounded-xl p-8">
              {service.icon}
              <span className="mt-4 text-lg font-medium">{service.title}</span>
            </div>
          ))}
        </div>
                <div className="max-w-xl space-y-3">
                    <h3 className="text-indigo-600 font-semibold">
                        We don’t just fix — we solve, support, and strengthen your business
                    </h3>
                    <p className="text-gray-800 text-3xl font-bold sm:text-4xl">
                        Tailored Solutions for Every Partner
                    </p>
                    <p>
                        At Matanato, we understand that behind every service request lies a responsibility — to your tenants, clients, and reputation. That’s why we’re more than just a vendor. We’re a hands-on, responsive partner who delivers consistent, cost-effective, and worry-free repair solutions designed to fit your business model.
                    </p>
                </div>
                
            <div className="overflow-x-auto mt-4">
          <table className="min-w-full bg-white border border-gray-200 rounded-xl shadow">
            <thead>
              <tr className="bg-gray-100 text-left">
                <th className="py-4 px-6 text-sm font-semibold text-gray-700 border-b border-gray-200 w-1/2">
                  Common Challenges
                </th>
                <th className="py-4 px-6 text-sm font-semibold text-gray-700 border-b border-gray-200 w-1/2">
                  Our Solutions
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, idx) => (
                <tr key={idx} className="hover:bg-gray-50 transition">
                  <td className="py-4 px-6 border-b border-gray-200 text-gray-800 align-top">
                    {item.challenge}
                  </td>
                  <td className="py-4 px-6 border-b border-gray-200 text-gray-700 align-top">
                    {item.solution}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

            </div>
        </section>
    )
}

export default Tailor;